// Load the initial configuration of the application,
// and parse all window['__what_ever__'] global variables.
import { AppConfig } from '../config/app-config';

// eslint-disable-next-line no-undef
__webpack_public_path__ = AppConfig.webpackPublicPath;
